import axiosClient from "./axiosClient";

const formService = {
  create: (studyId, data) => axiosClient.post(`/forms/study/${studyId}`, data),

  getAllByStudy: (studyId) => axiosClient.get(`/forms/study/${studyId}`),

  getSimple: (studyId) => axiosClient.get(`/forms/simple/${studyId}`),

  getById: (formId) => axiosClient.get(`/forms/${formId}`),

  update: (formId, data) => axiosClient.put(`/forms/${formId}`, data),

  delete: (formId) => axiosClient.delete(`/forms/${formId}`),

  countDocuments: (formId) => axiosClient.get(`/forms/${formId}/documents/count`)
};

export default formService;
